import $ from 'jquery';

class Woocommerce {
  constructor() {
    this.checkoutCompanyInvoiceFields();
  }

  checkoutCompanyInvoiceFields() {
    this.ciCheckbox = $('.js-company-invoice');
    this.ciFields = $('.js-show-if-company-invoice');

    if (this.ciFields.length) {
      if (this.ciCheckbox.find('input').is(':checked')) {
        this.ciFields.show();
      }

      this.ciCheckbox.on('change', 'input', e => {
        this.ciFields.toggle($(e.target).is(':checked'));
      });
    }
  }
}

export default new Woocommerce();



// WEBPACK FOOTER //
// ./src/scripts/modules/woocommerce.js